import React from 'react';
import { IAssignCompanyTagsDialogComponentStateModel } from './assign-company-tags-dialog';
import { DatePickerValue, DatePicker } from '../../../date-picker';
import { FormDialog } from '../../../form-dialog';
import { Box } from '../../../box';
import { Row } from '../../../row';
import { Cell } from '../../../cell';
import { SingleSelect } from '../../../single-select';
import { FormControl } from '../../../form-control/form-control';
import { Container } from '../../../container/container';
import { TagTypeOptionModel } from '../../../../areas/company/company-details/components/tags/company-tags-service';

export interface IAssignCompanyTagsDialogComponentProps {
  state: IAssignCompanyTagsDialogComponentStateModel;
  errors: IAssignCompanyTagsDialogComponentStateModel;
  tagTypeOptions: TagTypeOptionModel[];
  onChangeTagTypeOption: (value: TagTypeOptionModel) => void;
  onStartDateChange: (value: DatePickerValue) => void;
  onEndDateChange: (value: DatePickerValue) => void;
  isLoading?: boolean;
  isOpen: boolean;
  onConfirm: () => void;
  onClose?: () => void;
}

export function AssignCompanyTagsDialogComponent({
  state,
  errors,
  tagTypeOptions,
  onChangeTagTypeOption,
  onStartDateChange,
  onEndDateChange,
  isLoading,
  isOpen,
  onConfirm,
  onClose,
}: IAssignCompanyTagsDialogComponentProps) {
  return (
    <FormDialog
      open={isOpen}
      title="Tildel tag"
      confirmButtonText="Udfør"
      cancelButtonText="Afbryd"
      isLoading={isLoading}
      onConfirmClick={onConfirm}
      onClose={onClose}
      onCancelClick={onClose}
      maxWidth="lg"
      isValid
    >
      <FormControl fullWidth>
        <Container>
          <Box width="1000px">
            <Row>
              <Cell size="full">
                <SingleSelect<TagTypeOptionModel>
                  label="Type"
                  variant="outlined"
                  onChange={onChangeTagTypeOption}
                  disableClearable
                  value={tagTypeOptions?.find(p => p.id === state.tagTypeId)}
                  required
                  error={!!errors.tagTypeId}
                  errorText={errors.tagTypeId}
                  title="Søg på type"
                  options={tagTypeOptions ?? []}
                  renderOption={(optionProps: object, option: TagTypeOptionModel) => (
                    <li {...optionProps} key={option.id}>
                      {option.name}
                    </li>
                  )}
                  getOptionLabel={option => option.name ?? ''}
                  isOptionEqualToValue={(option, val) => option.id === val.id}
                />
              </Cell>
            </Row>
            <Row>
              <Cell size="half">
                <DatePicker
                  label="Start dato"
                  onChange={onStartDateChange}
                  value={state?.startDate}
                  variant="outlined"
                  fullWidth
                  required
                  error={!!errors.startDate}
                  errorText={errors.startDate}
                />
              </Cell>
              <Cell size="half">
                <DatePicker label="Slut dato" onChange={onEndDateChange} value={state?.endDate} variant="outlined" fullWidth error={!!errors.endDate} errorText={errors.endDate} />
              </Cell>
            </Row>
          </Box>
        </Container>
      </FormControl>
    </FormDialog>
  );
}
